import { axios, HOST, config } from "./settiing";

export default {
  /** reservation api **/
  getReservationPeriod(start, end, params) {
    let query = "";
    Object.keys(params).forEach((k) => (query = query + `${k}=${params[k]}&`));
    return axios.get(
      `${HOST}/manage/web/reservation/${start}/${end}?${query}`,
      config
    );
  },
  getReservation(reservationId) {
    return axios.get(`${HOST}/manage/reservation/${reservationId}`, config);
  },
  getDrivingReservation(driverId, reservationId) {
    return axios.get(
      `${HOST}/manage/reservation/driving/${driverId}/${reservationId}`,
      config
    );
  },
  getReservationWithPassengers(reservationId) {
    return axios.get(
      `${HOST}/manage/reservations/with-passengers/${reservationId}`,
      config
    );
  },
  getCanceledReservationWithPassengers(reservationId) {
    return axios.get(
      `${HOST}/manage/canceledReservation/with-passengers/${reservationId}`,
      config
    );
  },
  deleteReservation(reservationId) {
    return axios.delete(`${HOST}/manage/reservation/${reservationId}`, config);
  },
  getReservationPeriodForStatistic(start, end) {
    return axios.get(
      `${HOST}/manage/reservation/statistics/${start}/${end}`,
      config
    );
  },

  getReservationScheduleByDateGroupByDriver(date) {
    return axios.get(
      `${HOST}/manage/reservation/schedule/groupby/driver/${date}`,
      config
    );
  },

  getReservationScheduleByDate(date) {
    return axios.get(`${HOST}/manage/reservation/schedule/${date}`, config);
  },
  getReservationScheduleByDateNew(date, reservationId) {
    return axios.get(
      `${HOST}/manage/reservation/schedule/passive/${date}/${reservationId}`,
      config
    );
  },
  overlappedReserveData(data) {
    return axios.post(`${HOST}/manage/reservations/overlapped`, data, config);
  },
  addReservation(data) {
    return axios.post(`${HOST}/manage/reservation`, data, config);
  },
  addReservationWithPassengers(data) {
    return axios.post(
      `${HOST}/manage/reservations/with-passengers`,
      data,
      config
    );
  },
  manualReservation(data) {
    return axios.put(`${HOST}/manage/reservation/manual`, data, config);
  },
  updateReservation(data) {
    return axios.put(`${HOST}/manage/reservation`, data, config);
  },
  updateReservationWithPassengers(data) {
    return axios.put(
      `${HOST}/manage/reservations/with-passengers`,
      data,
      config
    );
  },

  deleteReservationByIdAndResvId(id) {
    return axios.delete(`${HOST}/manage/reservation/noalert/${id}`, config);
  },

  autoReservation(data) {
    return axios.post(`${HOST}/manage/reservation/auto/v3`, data, config);
  },

  getRecentLocationList(customerId) {
    return axios.get(`${HOST}/manage/reservation/recent/${customerId}`, config);
  },

  getReservationScheduleById(id, start, end) {
    return axios.get(
      `${HOST}/manage/reservation/driver/${id}/${start}/${end}`,
      config
    );
  },

  changeReservationState(data) {
    return axios.put(`${HOST}/manage/reservation/state`, data, config);
  },

  updateReservationPassenger(data) {
    return axios.post(`${HOST}/manage/reservation/passenger`, data, config);
  },

  checkDrivingReservation(driverIds) {
    return axios.post(
      `${HOST}/manage/reservation/driving-check`,
      driverIds,
      config
    );
  },
  getReservationRoute(routePackage) {
    return axios.get(
      `${HOST}/manage/reservation/route/${routePackage}`,
      config
    );
  },
  checkEnableReservation(reservationId) {
    return axios.get(
      `${HOST}/manage/reservation/check/${reservationId}`,
      config
    );
  },
  updateReservationPassengerCount(reservationId, data) {
    return axios.put(
      `${HOST}/manage/reservation/passenger-cnt/${reservationId}`,
      data,
      config
    );
  },
  addHelpServiceManager(reservationId, data) {
    return axios.put(
      `${HOST}/manage/reservation/help-service/${reservationId}`,
      data,
      config
    );
  },
};
